"use client";

import clsx from "clsx";
import {useTranslation} from "react-i18next";
import type {ToolApprovalStatus} from "./toolApprovalStatus";

interface ToolApprovalNoticesProps {
   status: ToolApprovalStatus;
   settled: boolean;
   expired: boolean;
   error: boolean;
   previewUnavailable?: boolean;
   className?: string;
}

/** Why an approval cannot be applied, or what happened after it was, for every review surface. */
export default function ToolApprovalNotices({status, settled, expired, error, previewUnavailable, className}: ToolApprovalNoticesProps) {
   const {t} = useTranslation("ask");
   const notices = [
      !settled && previewUnavailable && {key: "previewUnavailable", tone: "warning"},
      !settled && expired && {key: "expired", tone: "warning"},
      status === "failed" && {key: "failedDetail", tone: "error"},
      status === "indeterminate" && {key: "indeterminateDetail", tone: "warning"},
      error && {key: "submitError", tone: "error"},
   ].filter((notice): notice is {key: string; tone: "warning" | "error"} => !!notice);
   return notices.map(notice => <p key={notice.key} role="alert" className={clsx(className,
      notice.tone === "error" ? "text-red-700 dark:text-red-300" : "text-amber-700 dark:text-amber-300")}>
      {t(`toolApproval.${notice.key}`)}
   </p>);
}
